import type {
  LocationSubmitBody,
  LocationSubmitResponse,
} from '@/domains/landing-page/types/location-details.types';
import { request } from '@/shared/utils/request';

export const locationDetailsApi = {
  // POST /api/dsh/location/{token}/submit -> { latitude, longitude, address }
  submitLocation: async (
    token: string,
    body: LocationSubmitBody
  ): Promise<LocationSubmitResponse> => {
    return request.post<LocationSubmitResponse>(`/location/${token}/submit`, body);
  },
};
